import { Error } from "..";
import { Coordinates } from "../address";
import { Insights } from "./insightsTypes";

export interface Account {
    id: string;
    name: string;
    profile_picture_url: string;
    username: string;
    media_count: number;
    follows_count: number;
    followers_count: number;
    biography: string;
    website: string | null;
    engagement_score: string;
    engagement_rate: number | null;
    demographic_insights_sent_at: string | null;
    via_fb: boolean;
    via_ig: boolean;
    authenticity_score: number | null;
    engagement_rate_details: any | null;
    authenticity_score_details: {
        color: string;
    };
    status: string;
    reconnect: boolean;
    permissions: {
        [key: string] : string
    }
}

export interface SocialAccountBasic {
    uuid: string,
    handle: string,
    platform: string
}

export interface SocialAccount {
    uuid: string,
    handle: string,
    platform: string,
    followers_count: number,
    profile_picture_url: string,
    engagement_score: string,
    engagement_rate: string,
    engagement_rate_details: DisplayData,
    brand_collaborations?: string[],
    niches?: string[],
    languages?: string[],
    language_names?: string[],
    ig?: IGSocialAccount,
    yt?: YTSocialAccount
}

export interface YTSocialAccount {
    title: string | null;
    username: string;
    video_count: number;
    subscriber_count: number;
    view_count: number;
    description: string;
}


export interface IGSocialAccount {
    name: string,
    username: string,
    follows_count: number,
    followers_count: number,
    media_count: number,
    insights?: {
        demographic: SocialAccountDemographicInsights
    },
    averages?: {
        [key: string]: number
    },
    biography: string | null
}

export interface SocialAccountDemographicInsights {
    gender: Record<string, any>,
    age: Record<string, any>,
    country: Record<string, any>,
    city: Record<string, any>
}

interface DisplayData {
    name: string,
    color: string
}
export interface Influencer {
    name: string;
    platforms: string[];
    niches: number[];
    dob: string;
    gender: string;
    age: number;
    uuid: string;
    mobile: string;
    location: string | null;
    profile_picture_url: string;
    is_test: boolean;
    profile_completion: number;
    profile_missing: any | null;
    connect_ig: boolean;
    account: Account;
    ig_account?: Account;
    verification?: {
        handle: string,
        is_verified: boolean,
        error_code?: string,
        ig_account_id?: number,
        followers_count?: number
    }
    niche_names: string[];
    gender_name: string;
    coordinates?: Coordinates;
    lat: number | null;
    lng: number | null;
}

export interface InfluencerState {
    influencer: Influencer | null;
    influencerId: string | null;
    isConnected: boolean,
    loading: boolean,
    error: string | Error | null,
    accountId: string | null,
    igAccount: IGAccount | null,
    insights: Insights | null,
    connectionRequired: boolean,
    pan?: PANDetails | null,
    social_accounts : SocialAccountData[]
    selectedSocialAccount?: SocialAccountData| null,
    accountDeletionRequests: {
        last_fetched_at: number,
        items: any[],
        loading: boolean,
        error: string | null
    }
}

export interface SocialAccountData {
    status: string,
    permissions: Record<string, string>,
    social_account: SocialAccount
}

export interface PANDetails {
    id: number,
    entity_id: number,
    pan: string,
    registered_name: string,
    status: string,
    created_at: string,
    updated_at: string
}

export interface SetInfluencerAction {
    influencer: Influencer;
}

export interface SetInfluencerIdAction {
    influencerId: string;
}

export interface IGAccountsResponse {
    status: boolean;
    id?: string;
    error?: string;
    result?: {
        accounts: IGAccount[]
    };
}

export interface IGAccount {
    user_id: string,
    name: string,
    profile_picture_url?: string,
    username: string,
    id: string
}   

export interface FBPage { 
    [key: string]: any // Temporily set to any, later will be updated to Page type
}

export enum MediaProductType {
    STORY = 'STORY',
    REEL = 'REELS',
    FEED = 'FEED',
    YT = 'YT',
    VIDEO = 'VIDEO'
}

export interface Post {
    id: string;
    thumbnail_url: string;
    media_product_type: 'STORY' | 'FEED' | 'REELS';
    like_count: number;
    comments_count: number;
    impressions_count?: number;
    shares_count?: number;
    date: string;
    month: string;
    views_count?: number;
    reach_count?: number,
    insights?: Insights;
    caption?: string | null;
    posted_on?: string
    timestamp?: number
}

export interface PostsData {
    items: Post[],
    count: number,
    last_fetched_at: string
}


export enum MediaType {
    ALL= 'all',
    POSTS='posts',
    REELS='reels',
    STORIES='stories'
}

export enum SortOption {
    TIMESTAMP = "timestamp",
    TIMESTAMP_TZ="timestamp_tz",
    LIKE_COUNT = "like_count",
    COMMENTS_COUNT = "comments_count",
    REACH_COUNT = "reach_count",
    SHARES_COUNT = "shares_count"
}
